<div class="d-flex flex-column h-100">
  <as-split direction="vertical" [gutterSize]="20">
    <as-split-area [size]="50" [order]="1">
      <div class="d-flex flex-column h-100 asset-model-first-pane">
        <div class="d-flex align-items-center px-2 flex-shrink-0">
          <div class="mr-2">
            <button
              (click)="loadItems()"
              [ngClass]="{ 'btn-success': isLoading, 'btn-light': !isLoading }"
              class="btn btn-sm"
            >
              <i [ngClass]="{ 'la-spin': isLoading }" class="la la-refresh"></i>
            </button>
          </div>
          <div class="mr-2">
            <button
              (click)="assetModelGrid?.expandAll()"
              [disabled]="isLoading"
              class="btn btn-light btn-sm"
            >
              <i class="la la-expand-arrows-alt"></i>
            </button>
          </div>
          <div class="mr-2">
            <button
              (click)="assetModelGrid?.collapseAll()"
              [disabled]="isLoading"
              class="btn btn-light btn-sm"
            >
              <i class="la la-compress-arrows-alt"></i>
            </button>
          </div>
          <div class="mr-2">
            <button
              alt="clear filter"
              (click)="clearFilterAndResetModelsGrid()"
              [disabled]="!assetModelGrid?.isFilterApplied"
              [ngClass]="{
                'clear-filter position-relative':
                  assetModelGrid?.isFilterApplied
              }"
              class="btn btn-light btn-sm"
            >
              <i class="las la-filter"></i>
            </button>
          </div>
          <fieldset>
            <div class="mr-2" style="float: left">
              <button
                (click)="showEditModal()"
                [disabled]="
                  isLoading ||
                  selectedLifecycleStrategyNodes.length === 0 ||
                  auth.isViewer('fastlc')
                "
                class="btn btn-success btn-sm"
              >
                <i class="la la-plus"></i>
              </button>
            </div>
            <div
              [isDisabled]="selectedNodes.length === 0"
              class="btn-group mr-1"
              dropdown
            >
              <button
                class="dropdown-toggle btn btn-sm btn-primary"
                dropdownToggle
                type="button"
              >
                <ng-container *ngIf="selectedNodes.length > 0"
                  >{{ "navigations.with" | translate }}
                  <strong>{{ selectedNodes.length }}</strong>
                  {{ "navigations.selected" | translate }}
                </ng-container>
                <ng-container *ngIf="selectedNodes.length === 0">{{
                  "navigations.no_selection" | translate
                }}</ng-container>
                <span class="caret"></span>
              </button>
              <ul *dropdownMenu class="dropdown-menu">
                <li
                  (click)="showMassEditModal()"
                  class="btn btn-sm dropdown-item"
                  *ngIf="!auth.isViewer('fastlc')"
                >
                  <i class="la la-fw la-pencil-alt"></i>
                  {{ "navigations.edit" | translate }}
                </li>
                <li
                  (click)="assetModelGrid?.export('xlsx')"
                  class="btn btn-sm dropdown-item"
                >
                  <i class="la la-fw la-file-excel"></i> XLSX
                </li>
                <li
                  (click)="assetModelGrid?.export('csv')"
                  class="btn btn-sm dropdown-item"
                >
                  <i class="la la-fw la-file-csv"></i> CSV
                </li>
                <li
                  class="divider dropdown-divider"
                  *ngIf="!auth.isViewer('fastlc')"
                ></li>
                <li role="menuitem" *ngIf="!auth.isViewer('fastlc')">
                  <a
                    class="dropdown-item btn btn-sm btn-danger"
                    (click)="showMassDeleteConfirm()"
                  >
                    <i class="la la-fw la-trash"></i>
                    {{ "navigations.delete" | translate }}
                  </a>
                </li>
              </ul>
            </div>
            <div
              [isDisabled]="
                selectedNodes.length === 0 || auth.isViewer('fastlc')
              "
              class="btn-group mr-1"
              dropdown
            >
              <button
                class="btn btn-sm btn-primary"
                dropdownToggle
                type="button"
                (click)="showMassGradesModal()"
              >
                Assign Grade
              </button>
            </div>
          </fieldset>
        </div>
        <div
          class="d-flex h-100 w-100 flex-grow-1 pt-2 ag-grid-container asset-model-first-pane__grid"
        >
          <app-grid
            (rowDoubleClicked)="
              auth.isViewer('fastlc') ? null : onRowClicked($event)
            "
            (selectionChanged)="onSelectionChanged($event)"
            [gridOptions]="gridOptions"
            [rowData]="items"
            class="ag-theme-alpine"
            style="width: 100%; height: 100%"
            [autoGroupColumnDef]="assetModelGridAutoGroupColumnDef"
            [exportProcessCallBack]="exportProcessCallBack"
          >
          </app-grid>
        </div>
      </div>
    </as-split-area>
    <as-split-area [size]="50" [order]="2">
      <div class="position-relative">
        <button
          (click)="changeChildGrid()"
          [disabled]="isLoading"
          class="btn btn-sm btn-light position-absolute mr-1 asset__btn"
        >
          <i class="la la-exchange-alt la-lg"></i>
        </button>
        <span class="position-absolute asset__span">{{
          childGrid === "Action" ? "Actions" : "Conditions"
        }}</span>
      </div>
      <div class="h-100 w-100 pt-2" *ngIf="childGrid === 'Action'">
        <app-asset-action
          class="col-12 px-0 flex-column h-100"
          [sizeColumnsToFit]="sizeColumnsToFit"
          (reloadAssetModelGrid)="loadItems(false, false)"
          (changeSelectAssetModelNodes)="updateSelectedAssetModelNodes($event)"
          [selectedAssetModelNodes]="selectedNodes"
        >
        </app-asset-action>
      </div>
      <div
        class="d-flex h-100 w-100 flex-grow-1 pt-2"
        *ngIf="childGrid === 'Condition'"
      >
        <app-asset-condition-value
          class="col-12 px-0 flex-column h-100"
          [sizeColumnsToFit]="sizeColumnsToFit"
          (reloadAssetModelGrid)="loadItems(false, false)"
          (changeSelectAssetModelNodes)="updateSelectedAssetModelNodes($event)"
          [selectedAssetModelNodes]="selectedNodes"
        >
        </app-asset-condition-value>
      </div>
    </as-split-area>
  </as-split>
</div>
